enum ActionTypes {
  SEARCH_REQUEST = 'SEARCH_REQUEST',
  SEARCH_SUCCESS = 'SEARCH_SUCCESS',
  SEARCH_FAILURE = 'SEARCH_FAILURE'
}

export default ActionTypes;
